/* jshint esversion: 6 */
import React from 'react';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import { FormattedDate } from 'react-intl';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';

export default function ListModule(Component) {

	class ListModule extends React.Component {
		constructor(props) {
			super(props);

			this.formatLastRoutePostTime = this.formatLastRoutePostTime.bind(this);
			this.setStatus = this.setStatus.bind(this);
			this.newSocial = this.newSocial.bind(this);
			this.getOutputIcons = this.getOutputIcons.bind(this);

		}

		formatLastRoutePostTime(timeInSeconds) {
			let date = null,
				now = null,
				label = '',
				key = '',
				timeLabel = '';

			if (parseInt(timeInSeconds) <= 1 || moment === undefined) {
				return null;
			}

			date = new Date(parseInt(timeInSeconds) * 1000);
			now = moment();

			if (this.props.user && this.props.user.detail.timezone) {
				date = moment(date).tz(this.props.user.detail.timezone);
			} else {
				date = moment(date);
			}

			if ((now.unix() - date.unix()) > 604800000) {
				// it's been a while since this route posted, just use the date
				return date.format('MMM Do, YYYY');

			} else {
				return (
					<FormattedRelativeWrapper value={date.unix() * 1000}/>
				);
			}

		}

		setStatus(activeFlag, lastActionTimestamp) {
			let inactive = parseInt(activeFlag) === 0 ? true : false,
				status = {
					label: '\u00a0',
					icon: '',
					className: ''
				},
				setError = false,
				constants = this.props.app.config.constants,
				isProfile = false,
				disconnectedGroup = false,
				i = 0;

			// convert a regular date to seconds for the DateMixin

			if (typeof lastActionTimestamp === "string") {
				if (lastActionTimestamp.match(/^[\d]+$/) === null) {
					lastActionTimestamp = new Date(lastActionTimestamp).getTime() / 1000;
				}
			}

			// check for errors first. overrides any other condition so users can be
			// notified that something needs to be done
			if (this.props.route && this.props.route.type == constants.R_DEFAULT) {
				if (parseInt(this.props.route.errCount, 10) > 0) { // this will be the error case
					setError = true;
				}
				if (this.props.route.inputs) {
					for (i = 0; i < this.props.route.inputs.length; ++i) {
						if (parseInt(this.props.route.inputs[i].sysActionFlag, 10) > 0) {
							setError = true;
							break;
						}
					}
				}
			} else if (this.props.route && this.props.route.type == constants.R_CURATE_BASIC) {
				if (parseInt(this.props.input.errCount, 10) > 0) {
					setError = true;
				}
			}

			if (this.props.route && this.props.route.outputs && this.props.route.outputs.length) {
				for (i = 0; i < this.props.route.outputs.length; ++i) {
					if (this.props.route.outputs[i].social) {
						if (this.props.route.outputs[i].social.hasGroupApp !== undefined && this.props.route.outputs[i].social.hasGroupApp == 0) {
							disconnectedGroup = true;
						}
					}
				}
			}

			if (this.props.social) {
				// errCount obsoleted on social object 12/14/2022
				// if (parseInt(this.props.social.errCount, 10) > 0) {
				// 	setError = true;
				// }
				if (parseInt(this.props.social.sysActionFlag, 10) > 0) {
					setError = true;
				}
				if ((parseInt(this.props.social.psID, 10) === constants.POST_SVC_FACEBOOK &&
					parseInt(this.props.social.subType, 10) === constants.FB_PROFILE)) {
					isProfile = true;
				}
				if ((parseInt(this.props.social.psID, 10) === constants.POST_SVC_FACEBOOK &&
					parseInt(this.props.social.subType, 10) === constants.FB_GROUP) &&
					this.props.social.hasGroupApp !== undefined && this.props.social.hasGroupApp === 0) {
					disconnectedGroup = true;
				}
			}

			if (disconnectedGroup) {
				status.icon = <i className="fa fa-chain-broken"></i>;
				status.className += " error";
			}

			if (setError) {
				status.icon = <i className="fa fa-exclamation-circle error"></i>;
				status.className += " error";
			}

			if (isProfile) {
				let which = "facebookProfiles";
				status.icon = (
					<i className="fa fa-times-circle"></i>
				);
				status.label = (
					<HelpButton
						which={which}
						textButton="Profile not supported" />
				);
				status.className += " invalid-type";

				return status;
			}


			if (!setError && !disconnectedGroup) {
				// if an error condition isn't detected set up the status as normal
				if (parseInt(activeFlag) === 0) {
					status.label = "Inactive";
					status.icon = <i className="fa fa-pause"></i>;
				} else {
					if (inactive) {
						status.label = "Inactive";
						status.icon = <i className="fa fa-minus-circle"></i>;
					} else if (parseInt(lastActionTimestamp) > 0) {
						status.label = this.formatLastRoutePostTime(lastActionTimestamp)
						status.icon = <i className="fa fa-check-circle"></i>;
						status.className += " active";
					} else {
						status.label = "No recent posts";
						status.icon = <i className="fa fa-dot-circle-o"></i>;
					}

				}
			}

			return status;
		}

		newSocial(e) {
			let singleTwitter = true,
				constants = this.props.app.config.constants;

			if (this.props.route.inputs) {
				if (this.props.route.inputs.length === 1 && this.props.route.inputs[0].type == constants.INPUT_TYPE_TWITTER) {
					singleTwitter = false;
				}
			}

			let modal = (
				<SocialModal
					{...this.props}
					user={this.props.user}
					activeRoute={this.props.route}
					setModal={this.props.closeAllModals}
					routeId={this.props.route.id}
					outputs={this.props.route.outputs}
					context="list-add"
					router={this.props.router}
					recordPath={this.props.recordPath}
					activeTab="chooseType" />
			);
			e.preventDefault();
			e.stopPropagation();

			// if (this.props.user.perms.resources.outputsAvailable === 0) {
			// 	this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'social_banner');
			// } else {
				this.props.addModal(modal);
			// }

		}

		getOutputIcons(outputs, inactive) {
			let icons = [],
				iconInactive = inactive,
				retweet = false,
				countLabel = null,
				socialLabelClass = 'item-social-label',
				newSocialButton = null,
				constants = this.props.app.config.constants;

			if (inactive) {
				socialLabelClass += ' inactive';
			}

			for (let i = 0; i < outputs.length; ++i) {
				iconInactive = inactive;
				retweet = false;
				let disconnected = false;
				if (outputs[i].activeFlag == 0 || outputs[i].social.activeFlag == 0) {
					iconInactive = true;
				}
				if (parseInt(outputs[i].role) == constants.OR_ROLE_RETWEET) {
					retweet = true;
				}
				if (outputs[i].social.sysActionFlag === 1) {
					disconnected = true;
				}
				icons.push(
					<SocialAvatar
						key={i}
						social={outputs[i].social}
						compact={true}
						showCompactName={true}
						inactive={iconInactive}
						disconnected={disconnected}
						retweet={retweet} />
				);
			}

			if (outputs.length > 3) {
				countLabel = (
					<span className={socialLabelClass}>
						+ {outputs.length - 3} Socials
					</span>
				)
				icons = icons.slice(0, 3);
			}

			newSocialButton = (
				<div className="social-list-new-animated" onClick={this.newSocial} alt="Connect New Social" title="Connect New Social" role="button" aria-label="connect new social">
					<i className="icon ion-plus-round"></i>
				</div>
			);

			return (
				<div>
					{icons}
					{newSocialButton}
					{countLabel}
				</div>
			);

		}

		render() {
			return (
				<Component
					{...this.props}
					formatLastRoutePostTime={this.formatLastRoutePostTime}
					setStatus={this.setStatus}
					newSocial={this.newSocial}
					getOutputIcons={this.getOutputIcons} />
			);
		}

	}

	ListModule.displayName = "ListModule";

	return ListModule;

}
